var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSx(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.4v40H.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed2939",
    fillRule: "evenodd",
    d: "M.3 0h60v20H27z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002395",
    fillRule: "evenodd",
    d: "M.3 40h60V20H27z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.3 0 27 20 .3 40z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M13.8 15v-.2q-.2 0 0-.6s-.4-.2-.3-.5c0 0-.4-.1-.3-.5q-.2.1-.5-.4-.2 0-.5-.3-.2.1-.5-.2s-.4.2-.6-.2c0 0-.5.2-.6 0h-.6q-.4.4-.6.2-.3.3-.5.2-.4.4-.6.3-.2.4-.4.4l-.3.5c0 .3-.4.5-.4.5q.2.5 0 .6v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 15v-.2q-.2 0 0-.6s-.4-.2-.3-.5c0 0-.4-.1-.3-.5q-.2.1-.5-.4-.2 0-.5-.3-.2.1-.5-.2-.2.2-.6-.1-.2.1-.6-.2-.4.3-.6.2-.4.3-.6.1c0 .3-.5.2-.5.2q-.4.4-.6.3-.2.4-.4.4l-.3.5q-.1.5-.3.5v.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M13.6 14.7c-1-.1-2.2-.3-3.1.2q-1-.5-2.2-.3l-1.3.1q-1.2.1-2.2-.4l.6 3.6c.2 1.9-.9 3.4-.5 5.2q.7 1.3 2.2 1.5l2.9.5q.3 0 .5.4.8-.7 1.9-.7c1.2-.2 2.7-.1 3.5-1.2q.5-1.1.2-2.3l-.2-.7c-.7-2 0-4.3.3-6.3l-1.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80cfe1",
    d: "M15.2 20.4v.4c.2.9.4 2-.5 2.6s-2.3.3-3.5.6l-.7.5-.3-.3c-1-.5-2.2-.3-3.3-.6q-.8-.3-1.2-1.1c-.3-1.4.5-2.7.4-4.1q-.1-1.6-.5-3.2 1.3.6 2.7.3a4 4 0 0 1 2.2.2l1.2-.3 2.2.2q.8 0 1.4-.3c-.2 1.7-.7 3.4-.1 5.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.7 20.8v-1.6h.2l-2.4-1.6v-.8h.2l-1.2-.9-1.2.9h.2v.8l-2.4 1.6h.2v1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M13.7 20.8v-1.6h.2l-2.4-1.6v-.8h.2l-1.2-.9-1.2.9h.2v.8l-2.4 1.6h.2v1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.4 22.9v.4H6.6v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M14.4 22.9v.4H6.6v-.5h7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.1 22.8v-1.7h.4v1.7-1.7H7v-.3h7v.3h-.4v1.7-1.7h.3v1.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M7.1 22.8v-1.7h.4v1.7-1.6H7v-.4h7v.3h-.4v1.7-1.7h.3v1.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M8.6 22.4v-1.2h-.9v1.2h1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M8 21.5v.7h.4v-.7H8m5.2 1v-1.3h-.9v1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M12.5 21.5v.7h.5v-.7zm.7-1v-1.2h-1v1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M12.5 19.6v.7h.5v-.7zm-3.9.9v-1.2h-.9v1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M10.3 20.5v-1.2h-.9v1.2h1m-2.4-1v.7h.4v-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M9.6 19.6v.6h.5v-.6zm2 .9v-1.2h-.9v1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M11 19.6v.6h.4v-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.9 20.1v2.7H9.2v-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M9.1 21H12m-2.4 1.8V21m2 2v-2m.4-.8v2.7H9.2v-2.7zm1-1.1L11.4 18H9.6l-1.5 1zm-3.1-2v.6h1.4V17z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m10.5 16.2.8.5H9.7l.8-.5m-.4 1v.3h.7V17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.7 15.8c.3 0 .3 1 .3 1.4q.4 0 .8.6h-2.2q.4-.5.8-.6c0-.5 0-1.4.3-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M11 20.2h.3v.4H11v-.3m2.6-4.5c.3 0 .3 1 .3 1.4q.4 0 .8.6h-2.2q.5-.5.8-.6c0-.5.1-1.4.3-1.4Zm-4.4 4.4h.2v.4h-.2zm.4 0h.2v.4h-.2zm.4 0h.2v.4H10zm.5 0h.2v.4h-.2zm1 0h.1v.4h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M10.5 26.3a8 8 0 0 0 2.9-.5l1.3-.1v1.6c-1 .6-3.6.7-4.2.7a12 12 0 0 1-4.2-.7v-1.6l1.3.1q1.5.6 3 .5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 26.3a8 8 0 0 0 2.9-.5l1.3-.1v1.6c-1 .6-3.6.7-4.2.7a12 12 0 0 1-4.2-.7v-1.6l1.3.1c.6.3 2 .5 3 .5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "m3 19.6 1.2.4-.4 1.8-1 .2s-.2-1 .2-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 19.6 1.2.4-.4 1.8-1 .2s-.2-1 .2-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7e7e7e",
    d: "m3.8 21.8-1 .2.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.8 21.8-1 .2.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M2.3 21h1.1c0 1 .2 4.5 4.4 4.7L7.7 27c-5.2 0-5.6-4.4-5.4-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.4 27.2 1.3-.3m-5.4-6 1.1.1c0 1 .2 4.5 4.4 4.7L7.7 27c-5.2 0-5.6-4.4-5.4-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "m18 19.6-1.2.4.4 1.8 1 .2s.2-1-.3-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 19.6-1.2.4.4 1.8 1 .2q.2-.1-.2-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7e7e7e",
    d: "m17.2 21.8 1 .2-.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.2 21.8 1 .2-.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M18.6 21h-1c0 1-.2 4.5-4.4 4.7l.2 1.3c5.1 0 5.5-4.4 5.2-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.7 27.2-1.3-.3m5.2-6-1 .1c0 1-.1 4.5-4.4 4.7l.2 1.3c5.1 0 5.5-4.4 5.2-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009fc5",
    d: "M9.8 27v.1h-.3v-.3h.3zm-.4.5v-.3h.4l.1-.2v-.2h-.5zm.7-.6h.3l.1.1v.1h-.4zm0 .6v-.3h.3l.1.1v.2h.2v-.2h-.1v-.5H10zm.8-.1v-.5h.4v.4l-.2.1zm-.1-.5v.5l.3.1.3-.1v-.5l-.3-.2zm3.4-1h.2l.2.1h-.5v.5h.4v-.3h-.2.3v.3l-.2.1h-.3l-.1-.3V26zm.8 0 .2-.1h.1q.1.2 0 .2l-.2.1zm.2.6-.1-.3h.2l.1-.1h.1v.2h.2l-.1-.2h-.1v-.2q0-.2-.2-.2h-.1l-.3.1zm.9-.4-.4-.6.4-.3v.1l-.3.2.1.2.4-.2-.3.3zl.4-.2zm.3-1 .2-.2h.3l.1.2v.2l-.1.1zm.7.2V25l-.1-.1-.3-.2-.2.1-.2.3.6.5zm.4-.5-.6-.4v-.1l.7.4m.3-.5-.7-.2.2-.5-.1.4h.2l.2-.3-.1.4zl.2-.4zm.3-.8-.8-.2v-.1l.8-.2-.6-.2.7.1v.1l-.7.2zm0-1 .1-.2V22H18v.2l-.1.1h-.3v-.4h.2-.1l-.1.2v.1h.2V22h.1l.2-.1h.2zm-15.4 0v.4H3v-.3l.1-.1h.2l.1.2v.2l-.2.1v-.1l.1-.2v-.1H3v.4h-.4v-.3zm0 1 .7-.3.2.6h-.1l-.1-.4h-.3l.2.4h-.1l-.1-.3zl.1.5zm.3.8.7-.3v.1l-.4.5.7-.1v.1l-.6.4v-.1l.3-.2.2-.1-.7.1.4-.6-.2.1zm1.2 1L4 25l.2-.1h.1zm-.5 0 .2-.1.2.1.2.1h.1V25l-.2-.3zm.7.7.4-.7.4.3v.1l-.4-.2-.1.2.3.2-.4-.2zl.4.2zm1.1-.2.3.1v.2h-.3zm-.2.7.1-.3h.3v.3l.1.1V26H6v-.3l-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc715f",
    d: "M6.5 13.7c0-.2.8-.8 3.5-.5q.1.2.7.2l-.3-.1q-.3-.4.2-.5l2.2.3-1.3.2q-.5 0 0 .1c1.1 0 2.3-.4 3.5.5h-.7l-1.6-.1-.8.3c0 .1-.2.7-1.7.3-.2 0-1.1.2-1 0l-.7-.1c0-.2.7-.4.8-.5l-2-.1s-.9.2-.8 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008737",
    d: "M7 16q.3.2.5.1l.1.1h1.1l-.3.4.1.4v.2l-.4-.1v.1H8v.2q-.2 0-.2-.2v.2l-.2.6h-.2v-.3l-.3.3-.3-.3.2-.5-.3-.2c-.2-.2-.3.3-.5 0l.2-.5-.2-.2q-.3 0-.4-.4A1 1 0 0 1 7 16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "m7.2 16 .2.2h-.2v.2l-.1-.1h-.2V16H7zm.5.2.2.1v.1h-.5v-.1q0-.2.3-.1m-.6.2v.2h.3v.2H7v.2h-.2v-.3q0 .2-.2.1a.1.1 0 0 1 0-.2h.2l.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.4 16.5q-.1.1-.2 0 0-.1.2 0m.4.2v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M7.7 16.6v.2H8q0 .3-.2.2h-.1v.2l-.3-.1v-.2q0 .2-.3.1v-.1l.4-.1v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.6 16.8v.2h-.2z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSx);
export default __webpack_public_path__ + "static/media/sx.95f41b882a377c0d9c81e160de7ddc0e.svg";
export { ForwardRef as ReactComponent };